import { ConfirmDropComponent } from './../confirm-drop/confirm-drop.component';
import { MyteamsService } from './../_services/myteams.service';
import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { Playerinfobox2Component } from 'src/app/playerinfobox2/playerinfobox2.component';
import { TournamentpopupComponent } from './../tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from './../gamepreviewpopup/gamepreviewpopup.component';
import { WeekMetrixComponent } from './../weekMetrix/weekMetrix.component';
import { SwapPlayersComponent } from './../swapPlayers/swapPlayers.component';
import { MatchupComponent } from './../matchup/matchup.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material';
import { element } from '@angular/core/src/render3/instructions';
import html2canvas from './../../../node_modules/html2canvas/dist/html2canvas.min.js';
import { MainService } from '../_services/main.service';
import { ResultboardService } from '../resultboard/resultboard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MultiSwapPlayersComponent } from '../multiSwapPlayers/multiSwapPlayers.component';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { UserBalanceData } from './../store/actions/appActions';
@Component({
  selector: 'app-myteams',
  templateUrl: './myteams.component.html',
  styleUrls: ['./myteams.component.scss']
})

@HostListener('scroll', ['$event'])
export class MyteamsComponent implements OnInit, OnDestroy {
  @ViewChild("screenToCapture") screenToCapture: ElementRef;
  @ViewChild("canvasForSS") canvasForSS: ElementRef;
  @ViewChild("downloadLinkForSS") downloadLinkForSS: ElementRef;

  @ViewChild('leftSide') leftSide: ElementRef;
  @ViewChildren('lineup', { read: ElementRef }) playersContainer: QueryList<any>;
  sub_currentGame: Subscription;
  sub_isMobileScreen: Subscription;
  activeDraftListener: Subscription;
  pickChanges: Subscription;
  newLeague: Subscription;
  sub_result: Subscription;
  displayActiveContests= [];
  siteurl = `${environment.SITE_URL}`;
  isMobile = false;
  user: any = null;
  lgIndex = 0;
  tIndex = 0;
  mobileTabsIndex = 0;
  contestSearch = ''; // search string for contest filter
  searchTimer = null;
  standingsIndex = 0;
  preStandingsScroll = 0;
  moreRegular = false;
  moreTour = false;
  myEntries = false;
  initialLoad = true;
  doLiveUpdate = true;
  mrFullStandings = false;
  currentTab = 'live'; // upcoming, live, history
  contestFilters = 'all'; // all, cash, tournament, season
  currentOrder = 'asc';
  currentSort = "";
  showCanvasSS = false;
  allImgsArray = [];
  imageData = {};
  request_left = 0;
  showStandings = false;
  standingsLoading = true;
  standingsLoadMore = false;
  showPlayers = true;
  loadingMore = false;
  loadingContests = true;
  isLoading = true;
  updateTimer: any = null;
  leftScroll = 0;
  contests = [];
  displayContests = [];
  standings = [];
  contest: any = {};
  currentDisplay = 'both'; // left, right, both
  bucketURL = `${environment.assetURL}/assets/default/images/`;
  playerURL = `${environment.assetURL}/assets/uploads/players/`;
  playerImgFolder = `assets/uploads/players/`;
  logoUrl = 'assets/default/images/logo-red.png';
  logoUrlDark = 'assets/default/images/logo.png';
  isMac = false;
  games = {
    0: 'all',
    1: 'nhl',
    2: 'nfl',
    3: 'mlb',
    4: 'nba',
    5: 'pga'
  };
  curGame = '0';
  lgId = 0;
  tourId = 0;
  darkMode=false;
  browsername='';
  darkMode_ext='';
  errorMsg='';
  errorMsg2='';
  imgversion='1.1115';
  showLgBoard = false;
  seasonList = [];
  selectedSeason = 0;
  // hard-coded stat name translations for display
  stats = {
    'sppt': { priority: 217, name: 'PPT' },
    'stoi': { priority: 216, name: 'TOI' },
    'gppt': { priority: 261, name: 'TOI' },
    'gso': { priority: 258, name: 'SO' },
    'gga': { priority: 257, name: 'GA' },
    'gsa': { priority: 256, name: 'SA' },
    'gs': { priority: 255, name: 'S' },
    'gotl': { priority: 254, name: 'OT' },
    'gl': { priority: 253, name: 'Loss' },
    'gw': { priority: 252, name: 'W' },
    'ggs': { priority: 251, name: 'GS' },
    'sh': { priority: 215, name: 'HT' },
    'sfol': { priority: 214, name: 'FOL' },
    'sfow': { priority: 213, name: 'FOW' },
    'spm': { priority: 212, name: 'PIM' },
    'sbs': { priority: 211, name: 'BS' },
    'ssog': { priority: 210, name: 'SOG' },
    'ssha': { priority: 209, name: 'SHA' },
    'sshg': { priority: 208, name: 'SHG' },
    'sppp': { priority: 207, name: 'PPP' },
    'sppa': { priority: 206, name: 'PPA' },
    'sppg': { priority: 205, name: 'PPG' },
    'sp_minus': { priority: 204, name: '+/-' },
    'sp': { priority: 203, name: 'P' },
    'sa': { priority: 202, name: 'A' },
    'sg': { priority: 201, name: 'G' },
    'ggaa': { priority: 262, name: 'GAA' },
    'gsp': { priority: 263, name: '%' },
    'patt': { priority: 101, name: 'ATT' },
    'comp': { priority: 102, name: 'COMP' },
    'pyrd': { priority: 103, name: 'YDS' },
    'ptd': { priority: 104, name: 'TD' },
    'inth': { priority: 105, name: 'Int' },
    'p2pc': { priority: 107, name: '2pt' },
    'ratt': { priority: 108, name: 'Att' },
    'ryrd': { priority: 109, name: 'RYds' },
    'rtd': { priority: 110, name: 'TD' },
    'rcp': { priority: 112, name: 'Rec' },
    'rcyrd': { priority: 113, name: 'RecYds' },
    'rctd': { priority: 114, name: 'TD' },
    'ofmrt': { priority: 117, name: 'TD' },
    'kort': { priority: 119, name: 'TD' },
    'prtd': { priority: 120, name: 'TD' },
    'fmb': { priority: 121, name: 'Fum' },
    'fmbl': { priority: 122, name: 'FumL' },
    '2pc': { priority: 123, name: '2pt' },
    'piy': { priority: 124, name: 'PIY' },
    'fg19y': { priority: 125, name: '1-19' },
    'fg29y': { priority: 126, name: '20-29' },
    'fg39y': { priority: 127, name: '30-39' },
    'fg49y': { priority: 128, name: '40-49' },
    'fg50y': { priority: 129, name: '50+' },
    'fgm': { priority: 130, name: 'FGM' },
    'fgms': { priority: 131, name: 'MISS' },
    'paam': { priority: 132, name: 'XPM' },
    'paams': { priority: 133, name: 'MISS' },
    'pa0': { priority: 134, name: 'PA' },
    'pa6': { priority: 135, name: 'PA' },
    'pa13': { priority: 136, name: 'PA' },
    'pa20': { priority: 137, name: 'PA' },
    'pa27': { priority: 138, name: 'PA' },
    'pa34': { priority: 139, name: 'PA' },
    'pa35': { priority: 140, name: 'PA' },
    'sck': { priority: 141, name: 'Sck' },
    'irt': { priority: 142, name: 'TD' },
    'intr': { priority: 143, name: 'Int' },
    'fmry': { priority: 145, name: 'FumR' },
    'ofrt': { priority: 146, name: 'TD' },
    'mfgrt': { priority: 147, name: 'TD' },
    'bprt': { priority: 148, name: 'TD' },
    'bfgrt': { priority: 149, name: 'TD' },
    'blckk': { priority: 150, name: 'Blk' },
    'xpm': { priority: 151, name: 'XPM' },
    'miss': { priority: 152, name: 'MISS' },
    'hitbat': { priority: 300, name: 'AB' },
    'hitrns': { priority: 301, name: 'R' },
    'hithts': { priority: 302, name: 'H' },
    'hitssingle': { priority: 303, name: '1B' },
    'hitdbl': { priority: 304, name: '2B' },
    'hittrpl': { priority: 305, name: '3B' },
    'hithrns': { priority: 306, name: 'HR' },
    'hitrnsbat': { priority: 307, name: 'RBI' },
    'hitwlks': { priority: 308, name: 'BB' },
    'hithtsbp': { priority: 309, name: 'HBP' },
    'hitstrkout': { priority: 310, name: 'SO' },
    'hitstolnbas': { priority: 311, name: 'SB' },
    'hitcs': { priority: 312, name: 'CS' },
    'hitsac': { priority: 313, name: 'SAC' },
    'hitgdp': { priority: 314, name: 'GDP' },
    'pitchinnp': { priority: 315, name: 'IP' },
    'pitchwin': { priority: 316, name: 'W' },
    'pitchloses': { priority: 317, name: 'L' },
    'pitchsv': { priority: 318, name: 'SV' },
    'pitchbsv': { priority: 319, name: 'BSV' },
    'pitchstrkout': { priority: 320, name: 'SO' },
    'pitchhts': { priority: 321, name: 'H' },
    'pitchrnsern': { priority: 322, name: 'ER' },
    'pitchallowrun': { priority: 323, name: 'HR' },
    'pitchallowwalk': { priority: 324, name: 'BB' },
    'pitchhitbatsman': { priority: 325, name: 'HB' },
    'pitchwildpitch': { priority: 326, name: 'WP' },
    'pitchbalks': { priority: 327, name: 'BK' },
    'pitchstnlagainst': { priority: 328, name: 'SB' },
    'pitchbaserunner': { priority: 329, name: 'PO' },
    'pitchgdp': { priority: 330, name: 'GDP' },
    'pitchcg': { priority: 331, name: 'CG' },
    'pitchsho': { priority: 332, name: 'SHO' },
    'pitchno': { priority: 333, name: 'NH' },
    'pitchpg': { priority: 334, name: 'PG' },
    'hitavg': { priority: 335, name: 'AVG' },
    'hitobp': { priority: 336, name: 'OBP' },
    'hitslg': { priority: 337, name: 'SLG' },
    'hitops': { priority: 338, name: 'OPS' },
    'pitchera': { priority: 339, name: 'ERA' },
    'pitchwhip': { priority: 340, name: 'WHIP' },
    'hitsout': { priority: 341, name: 'K' },
    'pitchsout': { priority: 342, name: 'K' },
    'hitssacfl': { priority: 343, name: 'SAC' },
    'hitstobase': { priority: 340, name: 'BAS' },
    'defit': { priority: 144, name: 'TD' },
    'nbgs': { priority: 408, name: 'GS' },
    'nbmin': { priority: 400, name: 'MIN' },
    'nbpts': { priority: 401, name: 'PTS' },
    'nb3pm': { priority: 402, name: '3PM' },
    'nbreb': { priority: 405, name: 'REB' },
    'nboreb': { priority: 410, name: 'OREB' },
    'nbdreb': { priority: 411, name: 'DREB' },
    'nbass': { priority: 403, name: 'A' },
    'nbstl': { priority: 407, name: 'STL' },
    'nbblk': { priority: 406, name: 'BLK' },
    'nbmiss': { priority: 412, name: 'MISS' },
    'nbto': { priority: 404, name: 'TO' },
    'nbpm': { priority: 413, name: '+/-' },
    'sog': { priority: 218, name: 'OG' },
    'place': { priority: 414, name: 'Place' },
    'alb': { priority: 415, name: 'ALB' },
    'eag': { priority: 416, name: 'EAG' },
    'bir': { priority: 417, name: 'BIR' },
    'par': { priority: 418, name: 'PAR' },
    'bog': { priority: 419, name: 'BOG' },
    'dbog': { priority: 420, name: 'DBOG' },
    'other': { priority: 421, name: 'OTH' },
    'p1': { priority: 422, name: 'P1' },
    'p2': { priority: 423, name: 'P2' },
    'p3': { priority: 424, name: 'P3' },
    'p4': { priority: 425, name: 'P4' },
    'p5': { priority: 426, name: 'P5' },
    'p6': { priority: 427, name: 'P6' },
    'p7': { priority: 428, name: 'P7' },
    'p8': { priority: 429, name: 'P8' },
    'p9': { priority: 430, name: 'P9' },
    'p10': { priority: 431, name: 'P10' },
    'p11t15': { priority: 432, name: 'P11-15' },
    'p16t20': { priority: 433, name: 'P16-20' },
    'p21t25': { priority: 434, name: 'P21-25' },
    'p26t30': { priority: 435, name: 'P26-30' },
    'p31t40': { priority: 436, name: 'P31-40' },
    'p41t50': { priority: 437, name: 'P41-50' },
    'sft': { priority: 153, name: 'Sft' }
  };
  // hard-coded position translations for display
  positions = {
    'FLEX': 'FX',
    'UTIL': 'UT',
    'WR-TE': 'WT',
    'SFLEX': 'SF',
    'DEF': 'D'
  }
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  constructor(private store: Store<any>, public dialog: MatDialog,private _mainService: MainService, private _myTeamsService: MyteamsService,private _resultboardService:ResultboardService,private router: Router, private tournamentService: TournamentService) {
    if (navigator.appVersion.indexOf("Mac")!=-1) this.isMac =true;
    if (navigator.userAgent.match(/AppleWebKit/) && ! navigator.userAgent.match(/Chrome/)) {
      this.browsername = 'safaribrowser';
   }
    this.store.select('authData').subscribe(state => {
      if (state[0]) {
        this.user = state[0];
        if (this.curGame != null) this.loadContests();  
      }
    });
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
        if (this.isMobile && this.currentDisplay == 'both') {
          if (this.contest.status == null) {
            this.currentDisplay = 'left';
          } else {
            this.currentDisplay = 'right';
          }
        } else if (!this.isMobile) {
          this.currentDisplay = 'both';
        }
        if(this.isMobile){
          setTimeout(()=>{
            this.setupListeners('init');
          },500);
        }
      }
    });
    // this.sub_currentGame = this._lobbyService.cgObservable.subscribe(state => {
    //   if (state.game != null && this.curGame != state.game && !(this.curGame == 0 && state.game == 'all')) {
    //     this.curGame = (state.game == 'all') ? 0 : parseInt(state.game);
    //     if (this.user != null) {
    //       this.lgIndex = 0;
    //       this.tIndex = 0;
    //       this.contests = [];
    //       this.loadingContests = true;
    //       this.leftSide.nativeElement.scrollTop = 0;
    //       this.loadContests();
    //     }
    //   }
    // });
    // live updates
    this.updateTimer = setInterval(() => {
      this.updateContests();
    }, 60000);
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'-dark':'';
      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    clearInterval(this.updateTimer);
    if (this.activeDraftListener) this.activeDraftListener.unsubscribe();
    if (this.newLeague) this.newLeague.unsubscribe();
    if (this.pickChanges) this.pickChanges.unsubscribe();
  }

  loadContests(callback = null) {
    this.loadingMore = true;
    const season = this.selectedSeason || 0;
    this._myTeamsService.getContestListing(this.user.id, this.contestFilters, this.lgIndex, this.tIndex, this.currentTab, this.curGame, this.showPlayers, (this.contestSearch == '') ? null : this.contestSearch ,(this.currentTab != "history") ? null : season).subscribe(res => {
      if (res.status == 'success') {
        if (!res.contests.length && this.initialLoad) {
          this.currentTab = 'history';
          this.initialLoad = false;
          this.loadContests();
        }
        // parse results
        if (this.lgIndex == 0 && this.tIndex == 0) {
          this.contests = res.contests;
        } else {
          this.contests = [...this.contests, ...res.contests];
        }
        this.displayContests = this.contests;
        this.initialLoad = false;
        this.lgIndex = res.lgIndex;
        this.tIndex = res.tIndex;
        this.moreRegular = res.moreRegular;
        this.moreTour = res.moreTour;
        this.loadingMore = false;
        if (!this.isMobile && this.contest.status == null && this.contests.length) {
          if (this.contests[0].type == 'league') {
            this.loadContest(this.contests[0].slug);
          } else if (this.contests[0].type == 'tournament') {
            this.expandTour(this.contests[0], () => {
              if (this.contests[0].lgms.length) {
                this.loadContest(this.contests[0].lgms[0].slug);
              }
            });
          } else {
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
        }
        if (callback != null) callback();
      } else {
        this.isLoading = false;
      }
      this.loadingContests = false;
    });
  }

   
  getSeasonList (){
    this._myTeamsService.getSeasonList().subscribe(res => {
      if (res.status == 'success') {
        this.seasonList = res && res.entities ? res.entities : [];
      }
    });
  }

  getHeight(element) {
    const top = element.getBoundingClientRect().top;
    const wH = window.innerHeight;
    return wH - top - ((this.isMobile) ? 70 : 10);
  }

  contestsReset() {
    this.currentSort = null;
    this.lgIndex = 0;
    this.tIndex = 0;
    this.leftSide.nativeElement.scrollTop = 0;
    this.contests = [];
    this.displayContests = [];
    this.loadingContests = true;
    this.loadContests();
  }

  tabChange(event) {
    this.currentTab = event;
    if(this.currentTab == 'history') this.getSeasonList();
    if(this.currentTab=='drafting'){
      this.displayContests = [];
      this.setupListeners('change');
    }else {
      this.contestsReset();
    }
  }

  toggleDisplay() {
    switch (this.currentDisplay) {
      case 'both':
        this.currentDisplay = 'left';
        break;
      case 'left':
        this.currentDisplay = 'right';
        break;
      case 'right':
        this.currentDisplay = 'both';
        setTimeout(() => {
          this.leftSide.nativeElement.scrollTop = this.leftScroll;
        }, 50);
        break;
    };
  }

  getPMRStyle(pmr, total) {
    let percentage = Math.floor((pmr / total) * 100);
    let color = 'rgb(15,140,30)';
    if (percentage < 60) color = 'rgb(220,220,40)';
    if (percentage < 25) color = 'rgb(200,25,25)';
    return {
      'width': `${percentage}%`,
      'background-color': color
    };
  }

  contestScroll(event) {
    this.leftScroll = event.target.scrollTop;
    if (!this.loadingMore) {
      const top = event.target.scrollTop + event.target.clientHeight;
      const height = event.target.scrollHeight;
      const saved = event.target.scrollTop;
      if (top > height - 10) {
        // load more
        if (this.moreRegular || this.moreTour) this.loadContests(() => {
          event.target.scrollTop = saved;
        });
      }
    }
  }

  loadContest(slug, isStandings = false, isMove = false) {
    this.showLgBoard = false;
    if (this.contest.status == null || this.contest.data.slug == null || this.contest.data.slug != slug || isMove || this.isMobile) {
      this.isLoading = true;
      this.doLiveUpdate = true;
      if (!isStandings) this.myEntries = false;
      this.displayContests.forEach(c => {
        c.selected = (c.slug == slug);
      });
      // if (!this.isMobile) this.preStandingsScroll = this.leftScroll;
      if (this.currentDisplay == 'left') {
        this.currentDisplay = (this.isMobile) ? 'right' : 'both';
      }
      this._myTeamsService.getContestPlayers(slug,0,0,this.selectedSeason).subscribe(res => {
        if (res.status == true) {
          if (!isStandings) this.contest = {};
          this.contest.status = 'success';
          this.contest.data = res.entities;
          if (this.contest.data.draft_type == 4)
            this.contest.data.players.sort((a, b) => b.pn - a.pn);
          if (this.currentDisplay != 'both') {
            this.showStandings = false;
            this.mobileTabsIndex = 0;
          } else {
            if(this.contest.data.duration_id == 8) {
              this.showStandings = true;
            } else {
              const swapEnabled = this.contest.data.players.filter(element => element.is_swap == 1 || element.is_move == 1 || element.swap_cnf == 1 || element.move_undo == 1 || element.move_cnf == 1 || element.move_swap == 1);
              if(swapEnabled.length > 0) {
                this.showStandings = false;
              } else {
                this.showStandings = true; 
              }
            }
          }
          if (this.contest.data.weekSlider != null && this.contest.data.weekSlider.length) {
            let selected = this.contest.data.weekSlider.filter(w => w.selected == 1)[0];
            if (selected == null) selected = this.contest.data.weekSlider[0];
            this.contest.data.selectedWeek = selected.value;
          }
          this.contest.data.players.forEach(p => this.createStatsArray(p, this.contest.data));
          this.getURL(this.contest.data.players);
          const currentTime = (new Date()).getTime()/1000;
          const defaultDisplay = (this.contest.data.duration_id == 8 && this.contest.data.egs < currentTime) ? true : false;
          if (!this.isMobile && !this.showStandings && defaultDisplay == true) this.startStandings();
        } else {
          this.contest = {};
        }
        this.isLoading = false;
      });
    } else {
      if (this.currentDisplay != 'both') {
        this.showStandings = false;
        this.mobileTabsIndex = 0;
      }
    }
  }

  prettyEnd(value) {
    if (value % 100 > 10 && value % 100 < 14) {
      return 'th';
    } else {
      switch (value % 10) {
        case 1:
          return 'st';
          break;
        case 2:
          return 'nd';
          break;
        case 3:
          return 'rd';
          break;
        default:
          return 'th';
          break;
      };
    }
  }

  expandTour(contest, callback = null) {
    contest.loading = true;
    if (contest.type == 'tournament' && contest.lgm_ids.length && (contest.lgms == null || !contest.lgms.length)) {
      this._myTeamsService.expandTour(contest.lgm_ids, this.contestSearch,this.selectedSeason).subscribe(res => {
        // console.log(res);
        if (res.status == 'success' && res.contests.length) {
          if (res.contests[0]._tour_id > 0 && res.contests[0].is_gpp == 'N') {
            // locally filter out old round entries
            // sort desc by round_id
            res.contests.sort((a, b) => b.round_id - a.round_id);
            const used = {};
            // only add team_name once
            contest.lgms = [];
            res.contests.forEach(c => {
              if (used[c.team_name] == null) {
                used[c.team_name] = 1;
                contest.lgms.push(c);
              }
            });
            // sort back to rank asc
            contest.lgms.sort((a, b) => a.team_rank - b.team_rank);
          } else {
            contest.lgms = res.contests;
          }
          contest.loading = false;
          contest.expanded = true;
          if (callback != null) callback();
        }
      });
    }
  }

  startStandings() {
    this.mobileTabsIndex = 1;
    this.preStandingsScroll = this.leftScroll;
    this.showStandings = true;
  }

  toggleStandings() {
    if (!this.showStandings) {
      this.startStandings();
    } else {
      this.mobileTabsIndex = 0;
      this.showStandings = false;
      if (!this.isMobile) this.currentDisplay = 'left';
      setTimeout(() => {
        this.leftSide.nativeElement.scrollTop = this.preStandingsScroll;
      }, 150);
    }
  }

  standingsOff() {
    if (this.showStandings) {
      this.mobileTabsIndex = 0;
      this.showStandings = false;
      if (!this.isMobile) this.currentDisplay = 'left';
      setTimeout(() => {
        this.leftSide.nativeElement.scrollTop = this.preStandingsScroll;
      }, 150);
    }
  }

  openPlayerInfoBox(player, player_id, e) {
    e.preventDefault();
    e.stopPropagation();
    if ((player.infobox == null || player.infobox == 1) && player_id) {
      this.dialog.open(Playerinfobox2Component, {
        width: (this.isMobile) ? '90%' : '70%',
        height: 'auto',
        autoFocus: false,
        data: {
          isDraft: false,
          league: {
            game_id: this.contest.data.game_id,
            id: this.contest.data.league_id,
            abbr: this.games[this.contest.data.game_id],
            active_season_id: null
          },
          lgm_id: this.contest.data.lgm_id,
          players: [],
          player_data : {'pp' : player.pic, 'fn' : player.fn, 'ln' : player.ln},
          player_id,
          cache: false
        }
      });
    }
  }

  back() {
    this.currentDisplay = 'left';
    this.mobileTabsIndex = 0;
    this.showStandings = false;
    setTimeout(() => {
      this.leftSide.nativeElement.scrollTop = this.leftScroll;
    }, 50);
  }

  changeWeek() {
    this.isLoading = true;
    this.doLiveUpdate = false;
    this._myTeamsService.getContestPlayersWeek(this.contest.data.slug, this.contest.data.selectedWeek,this.selectedSeason).subscribe(res => {
      if (res.status) {
        const selectedWeek = this.contest.data.selectedWeek;
        this.contest.data = res.entities;
        this.contest.data.selectedWeek = selectedWeek;
      }
      this.isLoading = false;
    });
  }

  getSwapLink(player, contest) {
    if (contest.data.draft_type == 4) {
      return `${environment.SITE_URL}/${environment.ANGULAR_FOLDER_NMAE}/rankem/${this.games[contest.data.game_id]}/${contest.data.league_id}/${contest.data.lgm_id}`;
    } else if (contest.data.draft_type == 5) {
      return `${environment.SITE_URL}/drafts/tiers/${contest.data.league_id}/${contest.data.lgm_id}`;
    } else {
      return `${environment.SITE_URL}/player/swap-queue/${contest.data.lg_abbr}/${contest.data.lg_code}/${player.id}/remove/0/${player.lgm_id}/1`;
    }
  }

  clickMove(player, contest) {
    this.isLoading = true;
    this._myTeamsService.getContestPlayersMove(contest.data.slug, player.id).subscribe(res => {
      if (res.status) {
        this.contest.data = res.entities;
        // console.log(this.contest.data.players);
      }
      this.isLoading = false;
    });
  }

  // clickDrop(player, contest) {
  //   const movePlayer = contest.data.players.filter(p => p.move_undo == 1)[0];
  //   if (movePlayer) {
  //     this._myTeamsService.startMoveSession(movePlayer.id, movePlayer.gp_id, player.pick_rp, movePlayer.pick_rp, player.id, `${movePlayer.fn} ${movePlayer.ln}`, player.pick_cabbr).subscribe(res => {
  //       console.log(res);
  //     });
  //   }
  // }

  getDropLink(player, contest) {
    // $lg_abbr, $lg_code, $lgm_id, $moved_player, $moved_player_pos_id, $moved_player_pos, $move_to_player_pos, $swap_outplayer, $moved_player_name, $movTo_player_compPos
    const movePlayer = contest.data.players.filter(p => p.move_undo == 1)[0];
    return `${environment.SITE_URL}/player/move-session/${contest.data.lg_abbr}/${contest.data.lg_code}/${player.lgm_id}/${movePlayer.id}/${movePlayer.gp_id}/${movePlayer.pick_rp}/${player.pick_rp}/${player.id}/${encodeURIComponent(movePlayer.fn + ' ' + movePlayer.ln)}/${encodeURIComponent(movePlayer.pick_cabbr)}`;
  }

  confirmDrop(player, contest) {
    const movePlayer = contest.data.players.filter(p => p.move_undo == 1)[0];
    const dialogRef = this.dialog.open(ConfirmDropComponent, {
      width: (this.isMobile) ? '90%' : '50%',
      data: { player, movePlayer }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'success') {
        // redirect to move/drop
       // window.location.href = this.getDropLink(player, contest);
       this.showPlayersForSwap(player, contest,movePlayer)
      }
    });
  }

  showSwaps(player) {
    return player.is_move == 1 || player.is_swap == 1 || player.move_cnf == 1 || player.move_swap == 1 || player.move_undo == 1;
  }

  movePlayers(player, contest) {
    this.isLoading = true;
    const movePlayer = contest.data.players.filter(p => p.move_undo == 1)[0];
    this._myTeamsService.movePlayers(player.lgm_id, contest.data.league_id, movePlayer.id, player.id, this.user.id).subscribe(res => {
      // console.log(res);
      this.loadContest(contest.data.slug, false, true);
    });
  }

  contestLink(contest) {
    if (contest == null) return '';
    const lg_code = (contest.league_code != null) ? contest.league_code : contest.lg_code;
    return `${environment.SITE_URL}/league/profile/${this.games[contest.game_id]}/${lg_code}`;
  }

  draftLink(contest) {
    if (contest == null) return '';
    return `${environment.SITE_URL}/drafts/draft/${contest.league_id}`;
  }

  updateContests() {
    const time = Math.floor(Date.now() / 1000);
    if (this.contests.length && this.currentTab == 'live') {
      const lgms = [];
      const tours = [];
      this.contests.forEach(c => {
        if (c.type == 'league') {
          if (c.egs < time) lgms.push(c.lgm_id);
        } else {
          if (c.egs < time) {
            if (c.lgms != null && c.lgms.length) {
              c.lgms.forEach(l => lgms.push(l.lgm_id));
            }
            tours.push(c._id);
          }
        }
      });
      if (lgms.length || tours.length) {
        // send lgms + tours to new endpoint for runtime updates
        this._myTeamsService.liveRefresh(lgms, tours, this.user.id).subscribe(res => {
          if (res.result == 'success') {
            this.contests.forEach(c => {
              if (c.type == 'league') {
                if (res.uLgms[c.lgm_id] != null) {
                  Object.keys(c).forEach(k => {
                    if (res.uLgms[c.lgm_id][k] != null) c[k] = res.uLgms[c.lgm_id][k];
                  });
                  if (res.uLgms[c.lgm_id].display_total != null) c.team_total = res.uLgms[c.lgm_id].fpts;
                 // if (res.uLgms[c.lgm_id].this_week != null && c.duration_id == 8) c.pmr = res.uLgms[c.lgm_id].this_week;
                }
              } else if (c.type == 'tournament') {
                if (res.uTours[c._id] != null) {
                  c.best = res.uTours[c._id].rank;
                  c.team_total = res.uTours[c._id].fpts;
                  c.winning = res.uTours[c._id].cumulative;
                  c.tour_entrants = res.uTours[c._id].entrants;
                }
                if (c.lgms.length) {
                  c.lgms.forEach(l => {
                    if (res.uLgms[l.lgm_id] != null) {
                      Object.keys(l).forEach(k => {
                        if (res.uLgms[l.lgm_id][k] != null) l[k] = res.uLgms[l.lgm_id][k];
                      });
                      if (res.uLgms[l.lgm_id].display_total != null) l.team_total = res.uLgms[l.lgm_id].fpts;
                      //if (res.uLgms[c.lgm_id].this_week != null && c.duration_id == 8) c.pmr = res.uLgms[c.lgm_id].this_week;
                    }
                  });
                }
              }
            });
          }
          this.displayContests = this.contests;
        });
      }
    }
    // current contest update
    if (this.contest != null && this.contest.data.egs < time && this.doLiveUpdate) {
      // loadContest alternative here that only updates values and checks for changes -- trigger animations
      this._myTeamsService.getContestPlayers(this.contest.data.slug, 1, this.contest.data.lgm_id,this.selectedSeason).subscribe(res => {
        // console.log(res);
        if (res.status == true) {
          this.contest.status = 'success';
          const updated = res.entities;
          const oldW = this.contest.data.payout;
          const newW = updated.payout;
          if (Math.abs(oldW - newW) > 0.009) {
            // real change
            if (oldW > newW) {
              this.contest.data.winningDecrease = true;
            } else {
              this.contest.data.winningIncrease = true;
            }
          }
          this.contest.data.payout = newW;
          this.contest.data.pmr = updated.pmr;
          this.contest.data.pr = updated.pr;
          this.contest.data.team_total = updated.team_total;
          this.contest.data.players.forEach((p, i) => {
            if (p.id == updated.players[i].id) {
              const oldV = p.fpts;
              const newV = updated.players[i].fpts;
              if (Math.abs(oldV - newV) > 0.009) {
                // real change
                if (oldV > newV) {
                  p.fptsDecrease = true;
                } else {
                  p.fptsIncrease = true;
                }
              }
              p.fpts = newV;
              p.scores = updated.players[i].scores;
              p.result = updated.players[i].result;
            } else {
              p = updated.players[i];
            }
          });
          setTimeout(() => {
            this.contest.data.players.forEach(p => {
              p.fptsDecrease = false;
              p.fptsIncrease = false;
            });
            this.contest.data.winningIncrease = false;
            this.contest.data.winningDecrease = false;
          }, 4000);
        }
      });
    }
  }

  createStatsArray(player, contest) {
    if (player.events.length && player.events[0].scores != null) {
      player.stats = [];
      Object.keys(player.events[0].scores).forEach(k => {
        if (this.stats[k] != null && contest.sr[k] != null && player.events[0].scores[k] != 0)
          player.stats.push({ value: player.events[0].scores[k], priority: this.stats[k].priority, key: this.stats[k].name });
      });
      if (player.stats.length)
        player.stats.sort((a, b) => a.priority - b.priority);
    }
  }

  getContestType(contest) {
    const dt = (contest.draft_type == null) ? 1 : contest.draft_type;
    const du = (contest.duration_id == null) ? 1 : contest.duration_id;
    const draft_types = {
      1: 'Snake',
      4: 'Rank\'EM',
      5: 'Tiers',
      7: 'Cage Match'
    };
    const durations = {
      1: 'Daily',
      2: 'Weekly',
      3: 'Monthly',
      4: 'Full Season',
      5: 'Full Playoffs',
      6: 'Playoffs Round',
      7: '',
      8: 'Bestball'
    };
    if (contest.type == 'league') {
      return durations[du] + ' ' + draft_types[dt];
    } else {
      if (contest.is_gpp == 'Y') {
        return durations[du] + ' ' + draft_types[dt] + ' ' + 'GPP';
      } else {
        return 'Multi-Round';
      }
    }
  }

  sortContests(type) {
    // name, type, entries, winning, fpts, place, entrants, pmr, fee
    type = type==""?null:type;
    if (type == this.currentSort) {
      this.currentOrder = (this.currentOrder == 'asc') ? 'desc' : 'asc';
    }
    this.currentSort = type;
    const mult = this.currentOrder == 'asc' ? 1 : -1;
    const leagueTerms = {
      'name': 'lg_name',
      'winning': 'payout',
      'fpts': 'team_total',
      'place': 'team_rank',
      'entrants': 'entrants',
      'pmr': 'pmr',
      'fee': 'lg_fee'
    };
    const tourTerms = {
      'name': 'name',
      'winning': 'winning',
      'fpts': 'team_total',
      'place': 'best',
      'entrants': 'tour_entrants',
      'pmr': 'pmr',
      'fee': 'lg_fee'
    };
    this.displayContests.sort((a, b) => {
      if (type == 'type') {
        return this.getContestType(a) > this.getContestType(b) ? 1 * mult : -1 * mult;
      } else if (type == 'entries') {
        const first = a.type == 'league' ? 1 : a.lgm_ids.length;
        const second = b.type == 'league' ? 1 : b.lgm_ids.length;
        return first > second ? 1 * mult : -1 * mult;
      } else if (type == 'pmr') {
        const first = (a.pmr == null || a.duration_id == 8) ? 0 : a.pmr;
        const second = (b.pmr == null || b.duration_id == 8) ? 0 : b.pmr;
        return first > second ? 1 * mult : -1 * mult;
      } else if (type == 'name') {
        let first = a.type == 'league' ? a[leagueTerms[type]] : a[tourTerms[type]];
        let second = b.type == 'league' ? b[leagueTerms[type]] : b[tourTerms[type]];
        first = first.toLowerCase();
        second = second.toLowerCase();
        return first > second ? 1 * mult : -1 * mult;
      } else {
        const first = a.type == 'league' ? a[leagueTerms[type]] : a[tourTerms[type]];
        const second = b.type == 'league' ? b[leagueTerms[type]] : b[tourTerms[type]];
        return first > second ? 1 * mult : -1 * mult;
      }
    });
  }

  searchContests() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.currentSort = null;
      this.lgIndex = 0;
      this.tIndex = 0;
      this.leftSide.nativeElement.scrollTop = 0;
      this.contests = [];
      this.displayContests = [];
      this.loadingContests = true;
      this.loadContests();
    }, 750);
  }
  setType(type){
    this.contestFilters = type;
    this.lgIndex = 0;
    this.tIndex = 0;
    this.leftSide.nativeElement.scrollTop = 0;
    this.contests = [];
    this.displayContests = [];
    this.loadingContests = true;
    this.loadContests();
  }

  setSeason(value){
    this.selectedSeason = value;
    this.lgIndex = 0;
    this.tIndex = 0;
    this.leftSide.nativeElement.scrollTop = 0;
    this.contests = [];
    this.displayContests = [];
    this.loadingContests = true;
    this.loadContests();
  }

  clearSearch() {
    this.contestSearch = '';
    this.searchContests();
  }

  getCurrentlyWinning() {
    return this.contests.reduce((acc, e) => {
      if (e.type == 'league') {
        acc += parseFloat(e.payout);
      } else {
        acc += parseFloat(e.winning);
      }
      return acc;
    }, 0);
  }

  showEntrants(contest, lgm) {
    if (contest == null || lgm == null || contest.data == null) return '';
    if (contest.data._tour_id > 0 && contest.data.is_gpp == 'N') {
      // Multi-Round Tournament
      return (this.mrFullStandings) ? lgm.tour_entrants : lgm.entrants;
    } else {
      return (this.contest.data._tour_id > 0) ? lgm.tour_entrants : lgm.entrants;
    }
  }

  showRank(contest, lgm) {
    if (contest == null || lgm == null || contest.data == null) return '';
    if (contest.data._tour_id > 0 && contest.data.is_gpp == 'N') {
      // Multi-Round Tournament
      const count = this.standings.reduce((acc, o) => {
        if (this.mrFullStandings) {
          if (o.tour_rank == lgm.tour_rank) acc++;
        } else {
          if (o.team_rank == lgm.team_rank) acc++;
        }
        return acc;
      }, 0);
      if (count > 1) lgm.is_tie == 'Y';
      return (this.mrFullStandings) ? lgm.tour_rank : lgm.team_rank;
    } else {
      return (this.contest.data._tour_id > 0) ? lgm.tour_rank : lgm.team_rank;
    }
  }

  printPlayerName(player) {
    // (isMobile)?player.fn.substr(0,1)+'.':player.fn}} {{player.ln}}
    if (player.gp_id == 16) return player.fn;
    return (this.isMobile) ? `${player.fn.substr(0, 1)}. ${player.ln}` : `${player.fn} ${player.ln}`;
  }

  matchPlayersHeight(current) {
    //console.log('matchPlayersHeight', this.playersContainer);
    if (this.playersContainer != null && this.playersContainer.length) {
      // console.log(this.playersContainer.first);
      return this.playersContainer.first.nativeElement.clientHeight;
    } else {
      return this.getHeight(current);
    }
  }

  showMobStats(player) {
    if (this.isMobile) {
      if (player.showStats != null) {
        player.showStats = !player.showStats;
      } else {
        player.showStats = true;
      }
    }
  }

  mobileTabsChange(e, contest) {
    switch (e.index) {
      case 0:
        this.standingsOff();
        break;
      case 1:
        if (!this.showStandings) this.startStandings();
        break;
      case 2:
        window.location.href = this.contestLink(contest);
        break;
      case 3:
        window.location.href = this.draftLink(contest);
        break;
    };
  }

  fptsText(contest, player) {
    if (contest.draft_type != 4) {
      return contest.fptsText;
    } else {
      return `${Math.floor(Math.round((player.fpts / player.pn) * 100)) / 100} ${contest.fptsText}`;
    }
  }

  openLeague(league_id, tournament_id): void {
    let dialogRef = null;
    if (tournament_id == 0) {
      dialogRef = this.dialog.open(GamepreviewpopupComponent, {
        width: '800px',
        data: { league_id },
        autoFocus: false
      });
    } else {
      const remaining_people = 0;
      dialogRef = this.dialog.open(TournamentpopupComponent, {
        width: '800px',
        data: {
          league_id,
          tournament_id,
          remaining_people
        },
        autoFocus: false
      });
    }

    dialogRef.afterClosed().subscribe(result => {
      // console.log(result);
    });
  }

  weekMatrix(lgmData): void {
    let dialogRef = null;
    const width1 = (this.isMobile) ? '100%' : '90%';
    const width2 = (this.isMobile) ? '100%' : '50%';

    dialogRef = this.dialog.open(WeekMetrixComponent, {
      width: (lgmData.weekSlider.length > 5) ? width1 : width2,
      data: { lgmData },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {});
  }
  
  matchUp(lgmData): void {
    let dialogRef = null;
    dialogRef = this.dialog.open(MatchupComponent, {
      width: (this.isMobile) ? '100%' : '90%',
      data: { lgmData },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {});
  }

  downloadImage() {
            this.showCanvasSS =true;
            this.isLoading = true;
            setTimeout(()=>{
                html2canvas(this.screenToCapture.nativeElement,{scale:2,allowTaint:false,useCORS: true, backgroundColor: this.darkMode?"#0E1523":"#f5f5f5" }).then(canvas => {
                this.downloadLinkForSS.nativeElement.href = canvas.toDataURL("image/png");
                this.canvasForSS.nativeElement.src = canvas.toDataURL("image/png");
                this.downloadLinkForSS.nativeElement.download = "My-Team.png";
                this.downloadLinkForSS.nativeElement.click();
                this.showCanvasSS =false;
                this.isLoading = false;
              });
            },1000);
  }
  async getURL(players){
    return true;
    let newImg = [];
    this.request_left = 0;
    if(!this.allImgsArray.length){
      this.allImgsArray.push(this.logoUrlDark);
      this.allImgsArray.push(this.logoUrl);
      newImg.push(this.logoUrlDark);
      newImg.push(this.logoUrl);
    }
    players.forEach((player,key) => {
                let playerImgUrl = this.playerImgFolder+player.pic;
                if(this.allImgsArray.indexOf(playerImgUrl)==-1){
                  this.allImgsArray.push(playerImgUrl);
                  newImg.push(playerImgUrl);
                }
            });
      const chunks = [];
        for (let i = 0; i < newImg.length; i += 5) {
            const chunk = newImg.slice(i, i + 5);
            chunks.push(chunk);
        }
        this.request_left = chunks.length;
       for (let k = 0; k < chunks.length; k++) {
          this._mainService.getImageData(chunks[k]).subscribe(res => {
            this.request_left--;
            Object.keys(res).forEach((a,v) => {
            if(!Object.keys(this.imageData).includes(a)){
              this.imageData[a]= res[a];
            }      
          })
        });
      } 
   }
   prettyPrint(number) {
    const rem = number % 100;
    if (rem > 10 && rem < 21) {
      return number + 'th';
    } else {
      const rem2 = number % 10;
      if (rem2 == 1) return number + 'st';
      if (rem2 == 2) return number + 'nd';
      if (rem2 == 3) return number + 'rd';
      return number + 'th';
    }
  }
  
  setupListeners(type) {
    // active drafts emit (active_draft)
    this._resultboardService.emitActiveDraft({
      user_id: this.user.id,
      is_app: 1,
      is_connect: 1
    });

    if (this.activeDraftListener) this.activeDraftListener.unsubscribe();
    this.activeDraftListener = this._resultboardService.listActiveDraft().subscribe(r => {
      if (r.status == 1) {
        this.displayActiveContests = r.entities;
        let fastd = this.displayActiveContests.filter(ad=>ad.pick_time<600);
        let slowd = this.displayActiveContests.filter(ad=>ad.pick_time>=600);
        slowd.sort((a, b) => {
            return a.order_key-b.order_key;
        });
        this.displayActiveContests = fastd.concat(slowd);
        if(this.displayActiveContests.length>0 && type=='init'){
          this.currentTab = 'drafting';
        }
        this.startTimers();
        this._resultboardService.activeDraftVisibleEmit((this.displayActiveContests.length) > 0);
      }
    });
    if (this.newLeague) this.newLeague.unsubscribe();
    this.newLeague = this._resultboardService.getNewActiveLeague().subscribe(r => {
      r.entities.status = 1;
      this.displayActiveContests.push(r.entities);
      this._resultboardService.activeDraftVisibleEmit((this.displayActiveContests.length) > 0);
    });
    if (this.pickChanges) this.pickChanges.unsubscribe();
    this.pickChanges = this._resultboardService.pickChanges().subscribe(r => {
      if (this.displayActiveContests != null) {
        let selected:any;
        selected = this.displayActiveContests.filter(l => l.league_id == r.entities.active_draft.league_id);
        if (selected.length) {
          selected = selected[0];
          Object.keys(r.entities.active_draft).forEach(k => {
            selected[k] = r.entities.active_draft[k];
          });
          if (selected.status == 4) {
            if (selected.timer != null) clearInterval(selected.timer);
            setTimeout(() => {
              let index = -1;
              this.displayActiveContests.forEach((l, i) => {
                if (l.league_id == selected.league_id) index = i;
              });
              if (index > -1) this.displayActiveContests.splice(index, 1); // remove completed
              this._resultboardService.activeDraftVisibleEmit((this.displayActiveContests.length) > 0);
            }, 10000);
          }
          this.startTimers();
        }
        this._resultboardService.activeDraftVisibleEmit((this.displayActiveContests.length) > 0);
      }
    });
  }
  showMessage(league){
    return (league.status != 1) ? league.msg : 'Pre-Draft';
  }
  isMyPick(league) {
    return (league.pick_status == 1 || league.status == 1) && league.is_active == 1 && (league.is_paused == 'N' || league.is_paused == 0);
  }
  startTimers() {
    this.displayActiveContests.forEach(l => {
      if (l.timer != null) clearInterval(l.timer);
      if (l.is_active == 1 && (l.is_paused == 'N' || l.is_paused == 0)) {
        l.time_left--;
        l.timer = setInterval(() => {
          l.time_left--;
          l.clock = this.getPickClock(l.time_left);
          l.width = Math.floor((l.time_left / l.pick_time) * 100) + '%';
          if (l.time_left <= 0) clearInterval(l.timer);
        }, 1000);
      }
    });
  }
  getPickClock(timeleft) {
    if (timeleft > 60 * 60 * 24) {
      const days = Math.floor(timeleft / (60 * 60 * 24));
      return `${days} ${days > 1 ? 'days' : 'day'}`;
    } else if (timeleft > 60 * 60) {
      const hours = Math.floor(timeleft / (60 * 60));
      const minutes = Math.floor(timeleft / 60) % 60;
      const seconds = timeleft % 60;
      return `${this.tp(hours)}:${this.tp(minutes)}:${this.tp(seconds)}`;
    } else {
      const minutes = Math.floor(timeleft / 60);
      const seconds = timeleft % 60;
      return `${this.tp(minutes)}:${this.tp(seconds)}`;
    }
  }
  tp(val) {
    return (val.toString().length == 1) ? `0${val}` : `${val}`;
  }

  showPlayersForSwap(player, contest,movePlayer=null) {
    if (contest.data.draft_type == 4) {
      // let url = `${environment.SITE_URL}/${environment.ANGULAR_FOLDER_NMAE}/rankem/${this.games[contest.data.game_id]}/${contest.data.league_id}/${contest.data.lgm_id}`;
      let url = `/rankem/${this.games[contest.data.game_id]}/${contest.data.league_id}/${contest.data.lgm_id}`;
      this.router.navigate([url]);
    } else if (contest.data.draft_type == 5) {
      let url = `/tiers/${contest.data.league_id}/${contest.data.lgm_id}`;
      this.router.navigate([url]);
    } else {
      let dialogRef = null;
      dialogRef = this.dialog.open(SwapPlayersComponent, {
        width: (this.isMobile) ? '100%' : '50%',
        data: {
          player: player,
          movePlayer:movePlayer,
          league: {
            game_id: this.contest.data.game_id,
            id: this.contest.data.league_id,
            abbr: this.games[this.contest.data.game_id],
            active_season_id: null,
            leagueData:this.contest.data
          },
        },
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result.status == 'success') {
          this.loadContest(result.league_member_slug, false, true);
          if (result.multiSwap && movePlayer==null) {
            this._myTeamsService.getMultiSwapLeagues(result.multiSwap).subscribe(res => {
              result.leaguesList = res.entities;
              if (result.leaguesList.length > 0) {
                let dialogRef = null;
                result.type ='mlswap';
                dialogRef = this.dialog.open(MultiSwapPlayersComponent, {
                  width: (this.isMobile) ? '100%' : '50%',
                  data: result,
                  autoFocus: false
                });
                dialogRef.afterClosed().subscribe(leagueToRedirect => {
                  if(leagueToRedirect.league_member_slug)
                  this.loadContest(leagueToRedirect.league_member_slug, false, true);
                })
              } else {
                this._myTeamsService.getOtherLeaguesForMultiSwap(result.multiSwap).subscribe(res => {
                  result.leaguesList = res.entities;
                  if (result.leaguesList.length > 0) {
                    let dialogRef = null;
                    result.type ='mlinfo';
                    dialogRef = this.dialog.open(MultiSwapPlayersComponent, {
                      width: (this.isMobile) ? '100%' : '50%',
                      data: result,
                      autoFocus: false
                    });
                    dialogRef.afterClosed().subscribe(leagueToRedirect => {
                      if(leagueToRedirect.league_member_slug)
                      this.loadContest(leagueToRedirect.league_member_slug, false, true);
                    })
                  }
                  
                });
              }
            });
          }
        } else if (result.status == 'failure' || result.status =="started") {
          this.errorMsg = result.message;
          setTimeout(() => {
            this.errorMsg = '';
          }, 5000)
        }
      });
    }
  }
  openLgBoard(lgId, tourId) {
    this.lgId = lgId;
    this.tourId = tourId;
    this.showLgBoard = true;
  }
  getRGBAColor(color) {
    return 'rgba(' + parseInt('0x' + color.substr(1, 2), 16) + ',' + parseInt('0x' + color.substr(3, 2), 16) + ',' + parseInt('0x' + color.substr(5, 2), 16) + ',' + color.substr(8) + ')';
  }

  confirmDialog(e,league_code,league_name,seconds_per_pick,tournament_id) {
    e.preventDefault();
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '500px',
      data: { 'title': league_name, 'body': 'Are you sure you want to leave this league?','type':'confirm_popup' }
    });
     
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {
       if (res) {
        this.leaveLeague(league_code,seconds_per_pick,tournament_id);
       
       }
    })
  }

  leaveLeague(league_code,seconds_per_pick=0,tournament_id=0) {
    this.isLoading =true;
    this.sub_result = this.tournamentService.draftLeaveLeagueRequest({league_code, seconds_per_pick, tournament_id}).subscribe(res => {
       if (typeof res !== 'undefined' && res.status === 'success') {
        const updated_balance = (res.entities != null && res.entities.updated_balance != null) ? res.entities.updated_balance : '0';
        this.store.dispatch(new UserBalanceData(
          updated_balance
        ));
        this.isLoading =false;
        this.tabChange('upcoming');
      } else{
        this.errorMsg2 = res.message;
        setTimeout(() => {
          this.errorMsg2 = '';
        }, 10000);
        this.isLoading =false;
        this.tabChange('upcoming');
      }
    });
  }
}
